import { NgModule } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UserCapability } from 'identity-management';
import { isUserTypeBusinessGuardFn, isUserTypeCustomerFn } from './guards/user-type';
import { floatingModuleAuthFn } from './guards/floating-module-auth';
import { productGuard } from './guards/product/product.guard';
import { journeyStateProvider } from './providers/journey-state/journey-state.provider';
import { journeyHostEnvDataProvider } from './providers/journey-host-env-data/journey-host-env-data.provider';
import { AppRoutes, RouteJourneyPrefix } from 'shared-utils';
import { CustomLocationStrategyService } from './services/custom-location-strategy/custom-location-strategy.service';
import { loggedInGuard } from './guards/logged-in/logged-in.guard';
import { authenticationGuard } from 'auth';
import { isAuthorizedGuard } from 'shell-feature';

const routes: Routes = [
  {
    path: '',
    canActivate: [authenticationGuard],
    canActivateChild: [isUserTypeBusinessGuardFn],
    loadChildren: async () => (await import('./pages/main-page/main-page.module')).MainPageModule,
  },
  {
    path: AppRoutes.Floating,
    loadComponent: async () =>
      (await import('./pages/floating-module-page/floating-module-page.component')).FloatingModulePageComponent,
    canActivate: [floatingModuleAuthFn],
    canActivateChild: [isUserTypeCustomerFn],
    children: [
      {
        path: RouteJourneyPrefix.Partners,
        children: [
          {
            path: AppRoutes.TravelPartnersB2B2C,
            loadChildren: async () => (await import('travel-partners-sales-flow-journey')).TravelPartnersNl,
            canActivate: [isAuthorizedGuard, productGuard],
            data: {
              capabilities: [UserCapability.ContractCreation],
            },
            providers: [journeyStateProvider, journeyHostEnvDataProvider],
          },
        ],
      },
    ],
  },
  {
    path: AppRoutes.Login,
    canActivate: [loggedInGuard],
    loadChildren: async () => (await import('./pages/login-page/login-page.module')).LoginPageModule,
  },
  {
    path: AppRoutes.InvalidLink,
    loadComponent: async () =>
      (await import('./pages/invalid-link-page/invalid-link-page.component')).InvalidLinkPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
    }),
  ],
  providers: [{ provide: LocationStrategy, useClass: CustomLocationStrategyService }],
  exports: [RouterModule],
})
export class AppRoutingModule {}
